import React from 'react';
import { SignupForm } from './view/signupForm';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'SignupForm', 
  itemElt: (item, cmsOption) => <SignupForm item={item} cmsOption={cmsOption} />
}